import React, { createContext, useContext, useState } from "react"

type OverflowState = "auto" | "hidden"

interface LayoutContextType {
  overflow: OverflowState
  setOverflow: React.Dispatch<React.SetStateAction<OverflowState>>
}

export const LayoutContext = createContext<LayoutContextType>(null)
export const useLayoutContext = () => useContext(LayoutContext)

const LayoutProvider: React.FC<{
  children: (overflow: OverflowState) => React.ReactNode
}> = ({ children }) => {
  const [overflow, setOverflow] = useState<OverflowState>("auto")

  return (
    <LayoutContext.Provider value={{ setOverflow, overflow }}>
      {children?.(overflow)}
    </LayoutContext.Provider>
  )
}

export default LayoutProvider
